var p="768px";export{p as SM_VIEWPORT};
